import * as THREE from 'three';
import { FikoDxfCizici } from '../FikoDxfCizici';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';

export class FikoCizimDXF extends FikoGrup {
    override type: any = "FikoCizimDXF";
    /** */
    agactaGorunur = true;
    simge: string = "./sistem/simgeler/dxf.webp";
    sayac = 1;

    override komutlar = [
        {
            isim: "Gizle / Göster",
            simge: "eye",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            isim: "Gizle / Göster",
            simge: "eye",
            tiklandi: () => {
                this.sahne.cizgiSec();
            }
        }
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/dxf.webp";
    }

    dosyadan(dosya: any) {
        let _this = this;


        const loader: THREE.FileLoader = new THREE.FileLoader();

        loader.load(URL.createObjectURL(dosya), function (data: any) {
            let fikoDxfCizici = new FikoDxfCizici(_this.sahne, data as string)
            fikoDxfCizici.dxfParcala()
            fikoDxfCizici.varliklariOku();
            // fikoDxfCizici.varliklariOku1();
            _this.ekle(fikoDxfCizici);
            _this.sahne.anaGosterim.FikoYT.degisti.emit();
        });
        return this;
    }

    // raycast(raycaster: Raycaster, intersects: Intersection[]): void {
    //     // let _inverseMatrix = new THREE.Matrix4();
    //     let kesisenler = raycaster.intersectObjects(this.children, false);

    //     if (kesisenler.length > 0) {
    //         // // @ts-ignore
    //         // (kesisenler[0].object as THREE.Line).material.color.set(0x0000ff)
    //         // kesisenler[0].object = this;
    //         intersects.push(kesisenler[0]);
    //     }
    // }
}